import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/carRentInfo', request)
}

export {get}
